import React from "react";
import InformTable from "../Components/InformTable";

// Format: { "UpclickProductName": { old, new }, "ProductId": { old, new }, "UpclickProductId": "...", ... }
const MigrationUpdated: React.FC<{ action?: any }> = ({ action }) => {
    if (!action) return <p>No data available</p>;

    const exclude = ["UpclickProductId"];
    const scalarEntries = Object.entries(action).filter(
        ([key, val]) => !exclude.includes(key) && (typeof val !== "object" || val === null)
    );
    const changeEntries = Object.entries(action).filter(
        ([key, val]: [string, any]) => !exclude.includes(key) && val !== null && typeof val === "object" && ("old" in val || "new" in val)
    );

    const dataOld = changeEntries.map(([key, val]: [string, any]) => ({
        property: key,
        value: val?.old != null ? String(val.old) : "—",
    }));
    const dataNew = changeEntries.map(([key, val]: [string, any]) => ({
        property: key,
        value: val?.new != null ? String(val.new) : "—",
    }));

    const generalData = [
        { property: "Upclick Product ID", value: String(action.UpclickProductId ?? "—") },
        ...scalarEntries.map(([key, val]) => ({ property: key, value: String(val) })),
    ];

    return (
        <div className="inform_panel">
            <InformTable data={generalData} label="General" />
            {dataOld.length > 0 && <InformTable data={dataOld} label="Old Version" />}
            {dataNew.length > 0 && <InformTable data={dataNew} label="New Version" />}
        </div>
    );
};

export default MigrationUpdated;
